import { SearchContextDropdown } from '../useSearchContext';
import { SearchInputWrapper } from '../SearchInputWrapper';
import { withTheme } from '@emotion/react';
import React, { useRef, useState } from 'react';
import { Theme } from '@theme/base';

interface SearchContainerDropdownProps {
  icon: string;
  theme: Theme;
  render: any;
  title?: string;
  error?: string;
  onClickAway?: () => void;
  containerRef?: any;
  hideChevron?: boolean;
}

export const SearchContainerDropdownComponent = (props: SearchContainerDropdownProps) => {
  const { title, icon, render, containerRef, error, onClickAway, hideChevron } = props;
  const [active, setActive] = useState(false);
  const [lastClick, setLastClick] = useState(false);
  const searchRef: any = useRef();
  const ref = containerRef || useRef();

  const onBlur = () => {
    if (active) {
      setActive(false);
      onClickAway && onClickAway();
    }
  };

  const onMouseDown = () => {
    setActive(!active);
    setLastClick(true);
  };

  const onFocus = (event: any) => {
    if (lastClick) {
      setLastClick(false);
      return;
    }
    if (event.relatedTarget) {
      if (ref && ref.current && ref.current.contains(event.relatedTarget)) return;
    }
    setActive(!active);
  };

  return (
    <SearchContextDropdown.Provider value={{ searchRef, onBlur, active }}>
      <SearchInputWrapper
        active={active}
        error={error}
        icon={icon}
        onClickAway={onBlur}
        chevron={hideChevron ? false : true}
        onFocus={onFocus}
        onMouseDown={onMouseDown}
        tabIndex={0}
        title={title}
      >
        {render()}
      </SearchInputWrapper>
    </SearchContextDropdown.Provider>
  );
};

export const SearchContainerDropdown = withTheme(SearchContainerDropdownComponent);
